/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSearchConfigRequest
 */
export interface CreateSearchConfigRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSearchConfigRequest
     */
    noResultsMessages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigRequest
     */
    adminKey: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigRequest
     */
    readKey: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSearchConfigRequest
     */
    hosts: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigRequest
     */
    loadBalancedEndpoint: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigRequest
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSearchConfigRequest
     */
    name: string;
}

/**
 * Check if a given object implements the CreateSearchConfigRequest interface.
 */
export function instanceOfCreateSearchConfigRequest(value: object): value is CreateSearchConfigRequest {
    if (!('noResultsMessages' in value) || value['noResultsMessages'] === undefined) return false;
    if (!('adminKey' in value) || value['adminKey'] === undefined) return false;
    if (!('readKey' in value) || value['readKey'] === undefined) return false;
    if (!('hosts' in value) || value['hosts'] === undefined) return false;
    if (!('loadBalancedEndpoint' in value) || value['loadBalancedEndpoint'] === undefined) return false;
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateSearchConfigRequestFromJSON(json: any): CreateSearchConfigRequest {
    return CreateSearchConfigRequestFromJSONTyped(json, false);
}

export function CreateSearchConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSearchConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'noResultsMessages': json['noResultsMessages'],
        'adminKey': json['adminKey'],
        'readKey': json['readKey'],
        'hosts': json['hosts'],
        'loadBalancedEndpoint': json['loadBalancedEndpoint'],
        'hostname': json['hostname'],
        'name': json['name'],
    };
}

export function CreateSearchConfigRequestToJSON(value?: CreateSearchConfigRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'noResultsMessages': value['noResultsMessages'],
        'adminKey': value['adminKey'],
        'readKey': value['readKey'],
        'hosts': value['hosts'],
        'loadBalancedEndpoint': value['loadBalancedEndpoint'],
        'hostname': value['hostname'],
        'name': value['name'],
    };
}

